<template>
  <div class="swip">
    <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img v-lazy="image" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      images: [
        'https://img01.yzcdn.cn/vant/apple-1.jpg',
        'https://img01.yzcdn.cn/vant/apple-2.jpg'
      ]
    }
  },
  created() {},
  computed: {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.swip {
 //  margin-top: 0.25rem;
  width: 100%;
  border: 1px solid #000;
  // height: 0.88rem;
  height: 1.1rem;
  box-shadow: 0rem 0.01rem 0.02rem 0rem rgba(192, 192, 192, 0.08);
  ::v-deep .van-swipe {
    width: 100%;
    height: 100%;
    .van-swipe__track {
      width: 100% !important;
      .van-swipe-item {
        width: 100% !important;
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
